module.exports = __webpack_public_path__ + "img/logo_smfcu.11a4914e.png";